import { useState, useEffect } from 'react';
import axios from 'axios';
import { useStore } from 'react-redux';

import getEndpoint from '../endpoints';
import { useCurrentLanguage } from './useCurrentLanguage';

export function useMediaReleases({ year, adhoc }: { year: string; adhoc: string }): {
  media: unknown[];
  error: Error | null;
} {
  const lang = useCurrentLanguage() || 'de';
  const [media, setMedia] = useState([]);
  const [error, setError] = useState(null);
  const state = useStore();
  let query = `?lang=${lang}&year=${year}`;

  // adhoc has to be string to not cause a GDDS warning
  if (adhoc === '1') {
    query += `&adhoc=true`;
  }

  useEffect(() => {
    const loadReleases = async () => {
      try {
        const data = await axios.get(`${getEndpoint('mediaReleases', state)}/${query}`);
        setMedia(data?.data || []);
      } catch (e) {
        setError(e);
      }
    };
    loadReleases();
  }, [lang, year, adhoc]);

  return { media, error };
}
